import React, { FC, ReactNode } from 'react';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import useI18n from 'evcharging/hooks/useI18n';
import Paragraph from 'evcharging/components/Paragraph';
import Spacer from 'evcharging/components/Spacer';
import clsx from 'clsx';
import DarkLinkButton from 'evcharging/components/DarkLinkButton';
import Mobile from "../../evcharging/components/Mobile";

interface SolutionCardProps {
  image: string;
  title: string;
  text: ReactNode;
  label: string;
  href: string;
}

const SolutionCard: FC<SolutionCardProps> = (props) => {
  const { image, title, text, label, href } = props;
  const theme = useTheme();
  const styles = createStyles(theme, image);
  const { t } = useI18n();

  return (
    <div className={styles.root}>
      <div className={styles.image} />
      <div className={clsx(styles.bottom)}>
        <p className={styles.title}>{title}</p>
        <Spacer value={14} />
        <Paragraph color={'middle'} size={'x-small'}>
          {text}
        </Paragraph>
        <DarkLinkButton href={href}>{label}</DarkLinkButton>
      </div>
    </div>
  );
};

const createStyles = (theme: Theme, image: string) => ({
  root: css`
    display: flex;
    ${theme.breakpoints.mobile.down} {
      flex-direction: column;
    }
  `,
  image: css`
    background-image: url(${image});
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 12px;
    height: 200px;
    min-width: 285px;
    ${theme.breakpoints.mobile.down} {
      max-width: 350px;
      width: unset;
    }
  `,
  bottom: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    padding-left: 24px;
    ${theme.breakpoints.mobile.down} {
      padding-left: 0;
    }
    a {
      margin-top: auto;
      ${theme.breakpoints.mobile.down} {
        margin-top: 24px;
      }
    }
  `,
  title: css`
    color: #303940;
    font-weight: 800;
    font-size: 24px;
    line-height: 41px;
    ${theme.breakpoints.mobile.down} {
      font-size: 20px;
      padding-top: 24px;
    }
  `
});

export default SolutionCard;
